import PlatformFee from './platform-fee.view';

export default PlatformFee;
